import React from 'react';
import ReactDOM from 'react-dom';
import MediaQuery from 'react-responsive';

import {
  StyledHeader,
  StyledLogo,
  NavWrapper,
  StyledNavControl,
  StyledWrapper,
} from './styled';
import Nav from './Nav/Nav';
import VisuallyHidden from '@reach/visually-hidden';
import Menu from './icons/Menu';
import Close from './icons/Close';
import PropTypes from 'prop-types';

class Header extends React.Component {
  state = {
    isNavOpen: false,
  };
  render() {
    const { page } = this.props;
    const { isNavOpen } = this.state;
    const isHome = page === 'home';

    const iconColor = isHome ? '#fff' : '#181818';
    const headerColor = isNavOpen || isHome ? '#fff' : '#181818';

    const nav = (
      <NavWrapper open={isNavOpen}>
        <Nav page={page} color={headerColor} />
      </NavWrapper>
    );

    return (
      <StyledHeader isHome={isHome}>
        <StyledWrapper>
          <StyledLogo to="/">
            <svg width="197" height="24" viewBox="0 0 197 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill={isHome ? '#fff' : '#181418'}
                d="M191.908 17.927l-1.609 5.82h-4.827l2.397-8.477h1.851c.3-.004.599.05.878.16.279.109.533.272.747.478.214.206.384.452.5.723.116.271.176.562.176.856l-.113.44zm-16.043 0l-1.609 5.82h-4.828l2.398-8.477h1.834a2.314 2.314 0 0 1 1.626.638 2.174 2.174 0 0 1 .675 1.58c.032.144.032.294 0 .44M196.8.171l-3.975 14.043h-20.838L175.945.173h4.892l-2.671 9.546h11.071l2.671-9.546h4.892zM106.51 8.57l-4.232 15.175h-4.827l4.908-18.006h1.85a2.3 2.3 0 0 1 .877.154c.279.107.533.269.747.474a2.187 2.187 0 0 1 .677 1.573c.097.19 0 .362 0 .63zm9.317-3.885H94.522L95.809.172h21.306l-1.288 4.513zM9.655 23.745H0L5.069 5.74h1.85a2.3 2.3 0 0 1 .877.154c.28.107.533.269.748.474a2.2 2.2 0 0 1 .5.72c.117.27.177.56.176.853 0 .19 0 .362-.096.44L6.083 19.154h3.685a10.687 10.687 0 0 0 6.324-2.296 10.4 10.4 0 0 0 3.974-5.551c.155-.612.23-1.241.226-1.872a5.342 5.342 0 0 0-.982-2.988 4.586 4.586 0 0 0-2.59-1.572 8.029 8.029 0 0 0-1.61-.173H5.342L6.646.17h8.48c.994-.017 1.986.105 2.945.362a9.387 9.387 0 0 1 5.165 3.271 9.297 9.297 0 0 1 1.947 5.63 12.562 12.562 0 0 1-.466 3.146 15.371 15.371 0 0 1-5.632 7.863 16.799 16.799 0 0 1-9.43 3.302zm52.217-11.024L58.75 23.729h-4.827L57.8 10.047h1.738a2.3 2.3 0 0 1 .877.154c.279.108.533.27.747.474a2.2 2.2 0 0 1 .501.72c.116.27.176.56.176.854l.032.472zm20.855-4.419L71.833 23.746h-5.536L60.488.439V.172h4.442l4.795 18.903L83.08.172h6.839l-6.55 23.574H78.48l4.248-15.444zm58.557-3.617h-18.811L123.76.172h18.811l-1.287 4.513zm-5.358 19.06h-18.811l5.068-18.006h1.851a2.3 2.3 0 0 1 .877.154c.279.107.533.269.747.474a2.187 2.187 0 0 1 .677 1.573c.014.182-.013.365-.08.535l-.371 1.243h10.685l-1.287 4.434h-10.701l-1.384 5.033h13.935l-1.206 4.56zM52.105 4.686H33.294L34.58.172h18.81l-1.286 4.513zm-5.343 19.06H27.935L33.02 5.74h1.834c.301-.006.6.046.88.153.28.108.535.269.75.474.216.205.388.45.506.72.118.27.18.56.181.854.017.184-.016.368-.096.535l-.37 1.243h10.7l-1.303 4.434H35.498l-1.384 4.938H48.05l-1.288 4.655zm119.319-5.472a17.12 17.12 0 0 1-5.439 4.152 15.782 15.782 0 0 1-6.549 1.572c-1.025.018-2.048-.099-3.041-.345a9.67 9.67 0 0 1-5.246-3.366 9.537 9.537 0 0 1-1.947-5.709c.023-1.063.179-2.12.466-3.145a16.517 16.517 0 0 1 5.713-8.13 16.325 16.325 0 0 1 9.494-3.303c2.157-.029 4.276.556 6.099 1.683a8.81 8.81 0 0 1 3.685 4.718l-4.522 1.32a4.308 4.308 0 0 0-1.851-2.374 5.811 5.811 0 0 0-3.411-.896 10.912 10.912 0 0 0-6.549 2.39 11.704 11.704 0 0 0-4.136 5.74 7.28 7.28 0 0 0-.29 1.95 4.649 4.649 0 0 0 .995 3 4.837 4.837 0 0 0 2.707 1.718 5.668 5.668 0 0 0 1.753.173 10.43 10.43 0 0 0 4.426-1.053 13.243 13.243 0 0 0 3.958-3.004l3.685 2.91z"
              />
            </svg>
          </StyledLogo>
          <StyledNavControl
            onClick={() =>
              this.setState({
                isNavOpen: !isNavOpen,
              })
            }
          >
            <VisuallyHidden>
              {isNavOpen ? 'Закрыть' : 'Открыть'} меню
            </VisuallyHidden>
            {isNavOpen
              ? <Close fill={iconColor} />
              : <Menu fill={iconColor} />}
          </StyledNavControl>
          <MediaQuery query={`(min-width: 1280px)`}>
            {wide => {
              if (!wide && typeof document !== 'undefined') {
                return ReactDOM.createPortal(nav, document.getElementById
                  ('modal'));
              }

              return nav
            }}
          </MediaQuery>
        </StyledWrapper>
      </StyledHeader>
    );
  }
}

Header.propTypes = {
  page: PropTypes.string.isRequired,
};

export default Header;
